<template>
  <div>
    <slot v-bind="{ isServiceProvider, isCustomer, isClient }" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import recognition from './recognition';

export default defineComponent({
  computed: {
    isServiceProvider(): boolean {
      return recognition.isServiceProvider();
    },
    isCustomer(): boolean {
      return recognition.isCustomer();
    },
    isClient(): boolean {
      return recognition.isClient();
    },
  },
});
</script>
